import { removeNamespace } from '@/utils/helpers'
import { UserSearchMode } from '@/utils/enums/user-enums'
import UserService from '../../services/user.service'
import GiftCardsService from '../../services/giftcard.service'

export const USERS_TYPES = {
  mutations: {
    SET_LOADING_PAGE: 'users/SET_LOADING_PAGE',
    SET_SAVING: 'users/SET_SAVING',
    SET_LOADING_ADDRESS: 'users/SET_LOADING_ADDRESS',
    SET_LOADING_PAYMENT: 'users/SET_LOADING_PAYMENT',
    SET_SEARCH_MODE: 'users/SET_SEARCH_MODE',
    SET_PAGED_USERS: 'users/SET_PAGED_USERS',
    SET_TOTAL_USERS_COUNT: 'users/SET_TOTAL_USERS_COUNT',
    SET_USERS_TABLE_OPTIONS: 'users/SET_USERS_TABLE_OPTIONS',
    SET_USERS_SEARCH_TERM: 'users/SET_USERS_SEARCH_TERM',
    SET_SELECTED_USER: 'users/SET_SELECTED_USER',
    SET_SELECTED_USER_ADDRESSES: 'users/SET_SELECTED_USER_ADDRESSES',
    SET_SELECTED_USER_PAYMENT_METHODS: 'users/SET_SELECTED_USER_PAYMENT_METHODS',
    SET_SELECTED_USER_GIFT_CARD_PAYMENT_METHODS: 'users/SET_SELECTED_USER_GIFT_CARD_PAYMENT_METHODS',
    SET_SELECTED_USER_CUSTOMER_ROLES: 'users/SET_SELECTED_USER_CUSTOMER_ROLES',
    SET_SELECTED_CUSTOMER_ROLE_OPTIONS: 'users/SET_SELECTED_CUSTOMER_ROLE_OPTIONS',
    UPDATE_SELECTED_USER_ADDRESSES: 'users/UPDATE_SELECTED_USER_ADDRESSES',
    REMOVE_DELETED_ADDRESS: 'users/REMOVE_DELETED_ADDRESS',
    REMOVE_DELETED_PAYMENT_METHOD: 'users/REMOVE_DELETED_PAYMENT_METHOD',
    SET_CUSTOMER_ROLE_SEARCH_TYPE: 'users/SET_CUSTOMER_ROLE_SEARCH_TYPE'
  },
  actions: {
    fetchUsersPaged: 'users/fetchUsersPaged',
    fetchUser: 'users/fetchUser',
    fetchCustomerRoleOptions: 'users/fetchCustomerRoleOptions',
    saveUser: 'users/saveUser',
    addressChanged: 'users/addressChanged',
    saveNewAddress: 'users/saveNewAddress',
    deleteAddress: 'users/deleteAddress',
    saveNewPaymentMethod: 'users/saveNewPaymentMethod',
    deletePaymentMethod: 'users/deletePaymentMethod',
    setSearchMode: 'users/setSearchMode',
    saveNewGiftCard: 'users/SaveNewGiftCard',
    deleteGiftCard: 'users/DeleteGiftCard',
    changeCustomerRoleSearchType: 'users/changeCustomerRoleSearchType'
  }
}

const _types = removeNamespace('users', USERS_TYPES)

const state = () => ({
  loadingPage: false,
  saving: false,
  loadingAddress: false,
  loadingPayment: false,
  searchMode: UserSearchMode.AllUsers,
  usersTableOptions: {
    page: 1,
    itemsPerPage: 10
  },
  pagedUsers: [],
  totalUsersCount: 0,
  selectedUser: {},
  searchTerm: '',
  giftCardPaymentMethods: [],
  customerRoleSearchType: 0
})

const getters = {}

const mutations = {
  [_types.mutations.SET_LOADING_PAGE] (state, bool) {
    state.loadingPage = bool
  },
  [_types.mutations.SET_SAVING] (state, bool) {
    state.saving = bool
  },
  [_types.mutations.SET_LOADING_ADDRESS] (state, bool) {
    state.loadingAddress = bool
  },
  [_types.mutations.SET_LOADING_PAYMENT] (state, bool) {
    state.loadingPayment = bool
  },
  [_types.mutations.SET_SEARCH_MODE] (state, searchMode) {
    state.searchMode = searchMode
  },
  [_types.mutations.SET_PAGED_USERS] (state, pagedResult) {
    state.pagedUsers = pagedResult
  },
  [_types.mutations.SET_TOTAL_USERS_COUNT] (state, count) {
    state.totalUsersCount = count
  },
  [_types.mutations.SET_USERS_TABLE_OPTIONS] (state, options) {
    state.usersTableOptions = options
  },
  [_types.mutations.SET_USERS_SEARCH_TERM] (state, term) {
    state.searchTerm = term
  },
  [_types.mutations.SET_SELECTED_USER] (state, user) {
    state.selectedUser = {
      ...user,
      addresses: state.selectedUser.addresses,
      paymentMethods: state.selectedUser.paymentMethods,
      customerRoles: state.selectedUser.customerRoles
    }
  },
  [_types.mutations.SET_SELECTED_USER_ADDRESSES] (state, addresses) {
    state.selectedUser.addresses = addresses
  },
  [_types.mutations.SET_SELECTED_USER_PAYMENT_METHODS] (state, paymentMethods) {
    state.selectedUser.paymentMethods = paymentMethods
  },
  [_types.mutations.SET_SELECTED_USER_GIFT_CARD_PAYMENT_METHODS] (state, gcPaymentMethods) {
    state.giftCardPaymentMethods = gcPaymentMethods
  },
  [_types.mutations.SET_SELECTED_USER_CUSTOMER_ROLES] (state, customerRoles) {
    state.selectedUser.customerRoles = customerRoles
  },
  [_types.mutations.SET_SELECTED_CUSTOMER_ROLE_OPTIONS] (state, customerRoleOptions) {
    state.customerRoleOptions = customerRoleOptions
  },
  [_types.mutations.UPDATE_SELECTED_USER_ADDRESSES] (state, address) {
    var toUpdate = state.selectedUser.userAddresses.findIndex(x => x.addressId === address.id)
    state.selectedUser.userAddresses[toUpdate].address = address
  },
  [_types.mutations.REMOVE_DELETED_ADDRESS] (state, addressId) {
    var toRemove = state.selectedUser.userAddresses.findIndex(x => x.addressId === addressId)
    state.selectedUser.userAddresses.splice(toRemove, 1)
  },
  [_types.mutations.REMOVE_DELETED_PAYMENT_METHOD] (state, paymentMethodId) {
    var toRemove = state.selectedUser.paymentMethods.findIndex(x => x.id === paymentMethodId)
    state.selectedUser.paymentMethods.splice(toRemove, 1)
  },
  [_types.mutations.SET_CUSTOMER_ROLE_SEARCH_TYPE] (state, searchType) {
    state.customerRoleSearchType = searchType
  }
}

const actions = {
  [_types.actions.fetchUsersPaged] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING_PAGE, true)
    const { itemsPerPage, page } = state.usersTableOptions
    const maxResultCount = itemsPerPage
    const skipCount = (page - 1) * itemsPerPage
    console.log(state.customerRoleSearchType)
    UserService.getUsersPaged(skipCount, maxResultCount, state.searchTerm, state.searchMode, state.customerRoleSearchType)
      .then((res) => {
        const { items, totalCount } = res
        commit(_types.mutations.SET_PAGED_USERS, items)
        commit(_types.mutations.SET_TOTAL_USERS_COUNT, totalCount)
      })
      .finally(() => commit(_types.mutations.SET_LOADING_PAGE, false))
  },
  async [_types.actions.fetchUser] ({ commit }, id) {
    commit(_types.mutations.SET_LOADING_PAGE, true)
    await Promise.all([
      UserService.getUserById(id)
        .then((res) => {
          commit(_types.mutations.SET_SELECTED_USER, res)
          commit(_types.mutations.SET_SELECTED_USER_ADDRESSES, res.userAddresses)
        }),
      UserService.getUserPaymentMethods(id)
        .then((res) => commit(_types.mutations.SET_SELECTED_USER_PAYMENT_METHODS, res)),
      UserService.getUserGiftCardPaymentMethods(id)
        .then((res) => commit(_types.mutations.SET_SELECTED_USER_GIFT_CARD_PAYMENT_METHODS, res)),
      UserService.getCustomerRoles(id)
        .then((res) => commit(_types.mutations.SET_SELECTED_USER_CUSTOMER_ROLES, res)),
      UserService.getCustomerRoleOptions()
        .then((res) => commit(_types.mutations.SET_SELECTED_CUSTOMER_ROLE_OPTIONS, res))
    ]).finally(() => commit(_types.mutations.SET_LOADING_PAGE, false))
  },
  async [_types.actions.saveUser] ({ state, commit }, id) {
    commit(_types.mutations.SET_SAVING, true)
    await Promise.all([
      UserService.updateUserInfo(id, state.selectedUser),
      !state.selectedUser.isGuest && state.selectedUser.paymentMethods && state.selectedUser.paymentMethods.length && state.selectedUser.paymentMethods.filter(x => x.isDefault === true).length > 0
        ? UserService.setDefaultPaymentMethod(id, state.selectedUser.paymentMethods.find(x => x.isDefault).id)
        : null
    ])
    commit(_types.mutations.SET_SAVING, false)
  },
  [_types.actions.addressChanged] ({ commit }, address) {
    commit(_types.mutations.UPDATE_SELECTED_USER_ADDRESSES, address)
  },
  [_types.actions.saveNewAddress] ({ state, commit }, { id, address }) {
    commit(_types.mutations.SET_LOADING_ADDRESS, true)
    return UserService.createUserAddress(id, address)
      .then((res) => {
        commit(_types.mutations.SET_SELECTED_USER_ADDRESSES, [...state.selectedUser.addresses, res])
      })
      .finally(() => commit(_types.mutations.SET_LOADING_ADDRESS, false))
  },
  [_types.actions.deleteAddress] ({ commit }, { id, address }) {
    commit(_types.mutations.SET_LOADING_ADDRESS, true)
    return UserService.deleteUserAddress(id, address)
      .then(() => commit(_types.mutations.REMOVE_DELETED_ADDRESS, address.userAddressId))
      .finally(() => commit(_types.mutations.SET_LOADING_ADDRESS, false))
  },
  [_types.actions.saveNewPaymentMethod] ({ state, commit }, { id, paymentSourceToken, billingAddress }) {
    commit(_types.mutations.SET_LOADING_PAYMENT, true)
    return UserService.createUserPaymentMethod(id, paymentSourceToken, billingAddress)
      .then((res) => {
        commit(_types.mutations.SET_SELECTED_USER_PAYMENT_METHODS, [...state.selectedUser.paymentMethods, res])
      })
      .finally(() => commit(_types.mutations.SET_LOADING_PAYMENT, false))
  },
  [_types.actions.deletePaymentMethod] ({ commit }, { userId, methodId }) {
    commit(_types.mutations.SET_LOADING_PAYMENT, true)
    return UserService.deleteUserPaymentMethod(userId, methodId)
      .then(() => commit(_types.mutations.REMOVE_DELETED_PAYMENT_METHOD, methodId))
      .finally(() => commit(_types.mutations.SET_LOADING_PAYMENT, false))
  },
  [_types.actions.setSearchMode] ({ state, commit }, searchMode) {
    if (state.searchMode !== searchMode) {
      commit(_types.mutations.SET_SEARCH_MODE, searchMode)
      commit(_types.mutations.SET_USERS_SEARCH_TERM, '')
      commit(_types.mutations.SET_PAGED_USERS, [])
      commit(_types.mutations.SET_SELECTED_USER, {})
      commit(_types.mutations.SET_TOTAL_USERS_COUNT, 0)
      commit(_types.mutations.SET_USERS_TABLE_OPTIONS, {
        page: 1,
        itemsPerPage: 10
      })
    }
  },
  async [_types.actions.saveNewGiftCard] ({ commit }, payload) {
    await GiftCardsService.addPaymentMethod(payload.giftCardId, payload.userId)
    return await UserService.getUserGiftCardPaymentMethods(payload.userId)
      .then((res) => commit(_types.mutations.SET_SELECTED_USER_GIFT_CARD_PAYMENT_METHODS, res))
  },
  async [_types.actions.deleteGiftCard] ({ state, commit }, payload) {
    await GiftCardsService.removePaymentMethod(payload.giftCardId, payload.userId)
    return await UserService.getUserGiftCardPaymentMethods(payload.userId)
      .then((res) => commit(_types.mutations.SET_SELECTED_USER_GIFT_CARD_PAYMENT_METHODS, res))
  },
  [_types.actions.changeCustomerRoleSearchType] ({ state, commit, dispatch }, searchType) {
    commit(_types.mutations.SET_CUSTOMER_ROLE_SEARCH_TYPE, searchType)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
